import styled from 'styled-components';

import Column from '@sdk/components/ui/spacing/Column';
import Image from '@sdk/components/primitives/Image';

export const SideImg = styled(Column)`
  position: absolute;
  left: 0;
  pointer-events: none;

  @media (max-width: 1024px) {
    display: none;
  }
`;

export const MainSection = styled(Column)`
  width: 454px;

  @media (min-width: 1024px) {
    margin-left: 500px;
  }
`;

export const MaxHeightImage = styled(Image)`
  width: 60vw;

  @media (max-width: 1200px) {
    width: 65vw;
  }
`;
